import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import ko from './locales/ko.json';

const i18n = createI18n({
    legacy: false,
    locale: 'ko',
    fallbackLocale: 'en',
    messages: {
        en,
        ko,
    },
    warnHtmlMessage: false, // DOMPurify에서 xss 방어
});

export default i18n;
